// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__zOCGy","title":"Images45_title__3Q9Xv","images":"Images45_images__K_0LA"};